/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketspayoutstitle2Inputs */

const en_ticketspayoutstitle2 = /** @type {(inputs: Ticketspayoutstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payouts`)
};

const de_ticketspayoutstitle2 = /** @type {(inputs: Ticketspayoutstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auszahlungen`)
};

/**
* | output |
* | --- |
* | "Payouts" |
*
* @param {Ticketspayoutstitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketspayoutstitle2 = /** @type {((inputs?: Ticketspayoutstitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketspayoutstitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketspayoutstitle2(inputs)
	return de_ticketspayoutstitle2(inputs)
});
export { ticketspayoutstitle2 as "ticketsPayoutsTitle" }